<c-card *transloco="let t">
    <c-card-body class="px-2" *ngIf="group">

            <c-row>
              <c-col class="col-lg-6 col-12">
                  <h1>{{ t('Escalation Procedure for') }} {{group.name}}</h1>
              </c-col>
              <c-col class="col-lg-6 col-12 text-end">
                <button color="light" cButton class="m-1" routerLink="/mgmt/group/{{id}}">
                  <svg cIcon class="me-2" name="cil-chevron-left"></svg>
                  {{ t('Return to Group') }}
                </button>
                <a class="btn btn-primary" href="https://okalone.zendesk.com/hc/en-gb/articles/35352948598673-Understanding-Setting-up-an-Escalation-Procedure" target="_new" role="button"><i class="fa-regular fa-circle-question"></i> {{ t('Escalation Procedure Help') }}</a>
              </c-col>
            </c-row>

            <c-row *ngIf="escalation">
              <c-col class="col-12">
                <div class="alert alert-secondary" role="alert" *ngIf="!okService.isDismissed('group_escalation_info')">
                  <button type="button" class="btn btn-outline-secondary btn-sm float-end" (click)="okService.doDismiss('group_escalation_info')">{{ t('Close') }}</button>
                    <b class="text-danger">{{ t('THIS IS NOT AN AUTOMATED PROCESS') }}</b> <br/>
                    {{ t('The Escalation Procedure contains manual steps, for Monitors to assist Workers, should a Check In be missed or a Help Alert is issued.') }} <br/>
                    {{ t('For ') }}<b>{{ t('automated alerts') }}</b> {{ t('please use ') }}<a href="https://okalone.zendesk.com/hc/en-gb/articles/35353033606289-Setting-Up-Worker-Reminders" target="_new">{{ t('Worker Reminders') }}</a> {{ t('or') }} <a href="https://okalone.zendesk.com/hc/en-gb/articles/35352962127377-Alert-Loops-Sequenced-Monitor-Alerts" target="_new">{{ t('Alert Loops') }}</a>, {{ t('which are part of our')}} <a href="https://www.okaloneworker.com/what-is-the-comms-plan/" target="_new">{{ t('Comms Plan') }}</a>. <br/>

                    <b>{{ t('The procedure you are seeing is the Group Escalation Procedure. It will apply to workers in this group UNLESS they have a unique escalation procedure in their worker profile. The group procedure OVER-RIDES the company procedure, and a worker procedure OVER-RIDES any group or company procedures.') }}</b>

                    <b>{{ t('If you are using the Safety Monitoring Center then this Escalation Procedure will not be used. Please see the specific Escalation Plan for the Safety Monitoring Center.') }}</b>
                  </div>


                <ng-container *ngIf="!editing">

                  <button type="button" class="btn btn-outline-primary me-1" (click)="chooseEdit('wizard')">
                    <span *ngIf="escalation.type=='wizard'"><i class="fa-solid fa-pencil"></i> {{ t('Edit the Group Escalation Procedure') }}</span>
                    <span *ngIf="escalation.type!='wizard'"><i class="fa-solid fa-plus"></i> {{ t('Build Group Escalation Procedure') }}</span>
                  </button>

                  <button type="button" class="btn btn-outline-primary me-1" (click)="chooseEdit('custom')">
                    <span *ngIf="escalation.type=='custom'"><i class="fa-solid fa-pencil"></i> {{ t('Edit the Group Escalation Procedure') }}</span>
                    <span *ngIf="escalation.type!='custom'"><i class="fa-solid fa-plus"></i> {{ t('Enter my Own Group Escalation Procedure') }}</span>
                  </button>

                  <button type="button" class="btn btn-outline-warning" (click)="deleteEscalation()" *ngIf="escalation.type!='none'">{{ t('Delete the Escalation Procedure') }}</button>

                </ng-container>

                <app-escalation-edit-custom *ngIf="editing && edit_view=='custom'" type="group" [id]="id" [escalation]="escalation" (completed)="onCompleted($event)"></app-escalation-edit-custom>

                <app-escalation-edit-wizard *ngIf="editing && edit_view=='wizard'" type="group" [id]="id" [escalation]="escalation" (completed)="onCompleted($event)"></app-escalation-edit-wizard>

                <br/><br/>

                <div class="alert alert-warning" role="alert" *ngIf="!escalation">
                  {{ t("You don't have a group escalation. The company escalation will be used instead.") }}
                </div>

                <div class="card" *ngIf="escalation && !editing">
                  <div class="card-header">
                    {{ t('Your current Group Escalation Procedure') }}
                  </div>
                  <div class="card-body" [innerHtml]="escalation.html">

                  </div>
                </div>

              </c-col>
            </c-row>



</c-card-body>
</c-card>
